import { signInAuthProvider, loginRequest } from 'auth';
import { get } from 'lodash';
import { APPLICATION_NAMESPACE, APPLICATION_ID } from './authConstants';

async function getAccessToken() {
  const accounts = signInAuthProvider.getAllAccounts();
  if (accounts.length > 0) {
    const request = {
      scopes: [
        `https://${APPLICATION_NAMESPACE}.onmicrosoft.com/${APPLICATION_ID}/User.Read`
      ],
      account: accounts[0]
    };
    try {
      const accessToken = await signInAuthProvider.acquireTokenSilent(request);
      return accessToken;
    } catch (error: unknown) {
      // Do not fallback to interaction when running outside the context of MsalProvider. Interaction should always be done inside context.
      console.log(error);
      // InteractionRequiredAuthError: interaction_required: AADB2C90077: User does not have an existing session and request prompt parameter has a value of 'None'
      if ((get(error, 'message') ?? '').indexOf('AADB2C90077') > -1) {
        signInAuthProvider.loginRedirect(loginRequest).catch(console.error);
      }
      return null;
    }
  }

  return null;
}

export default getAccessToken;
